import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flw-overlay"
}
const _hoisted_2 = {
  class: "flw-box",
  role: "alertdialog",
  "aria-live": "assertive",
  "aria-label": "Deslogado pelo sistema"
}
const _hoisted_3 = { class: "flw-countdown" }
const _hoisted_4 = { class: "flw-title" }
const _hoisted_5 = { class: "flw-desc" }

import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { showForceLogout, forceLogoutSecondsLeft, forceLogoutKind, continueForcedSession, logoutNowForced } from '@/composables/useForceLogout'


export default /*@__PURE__*/_defineComponent({
  __name: 'ForceLogoutWarningModal',
  setup(__props) {

const store  = useStore()
const router = useRouter()

function handleContinue() {
  continueForcedSession(store)
}

function handleLogout() {
  logoutNowForced(store, router)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "flw-fade" }, {
      default: _withCtx(() => [
        (_unref(showForceLogout))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(forceLogoutSecondsLeft)), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(forceLogoutKind) === 'session' ? 'Esta sessão foi revogada pelo Sistema' : 'Você foi deslogado pelo Sistema'), 1),
                _createElementVNode("div", _hoisted_5, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Caso queira revogar esta ação, clique em ", -1)),
                  _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Continuar logado", -1)),
                  _cache[2] || (_cache[2] = _createTextVNode(". Senão, você será desconectado em ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(forceLogoutSecondsLeft)) + "s", 1),
                  _cache[3] || (_cache[3] = _createTextVNode(". ", -1))
                ]),
                _createElementVNode("div", { class: "flw-actions" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "flw-btn flw-btn--primary",
                    onClick: handleContinue
                  }, " Continuar logado "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "flw-btn flw-btn--muted",
                    onClick: handleLogout
                  }, " Deslogar ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})